export default {
  title: {
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal',
    identityConcession: 'Identificación concesión',
    actData: 'Datos del conductor',
    okData: 'Datos guardados correctamente',
    identityDriver: 'Identificación conductor',
    signData: 'Revise sus datos',
    signCompleted: 'Acta de entrega firmada'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos',
      loadingDocuments: 'Cargando documentos'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAcceptAndContinue: 'Aceptar y continuar',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnSign: 'Enviar a la firma',
      btnYes: 'Si',
      btnNo: 'No',
      btnValidating: 'Validando...',
      btnCancelPickup: 'Cancelar la recogida',
      btnDriverGuide: 'Guía del conductor'
    },
    label: {
      step1: 'Identificación',
      accordionIdentity: 'Confirma tu identidad',
      allDataRequired: 'Todos los datos son obligatorios'
    },
    placeholder: {
      cifConcession: 'CIF Concesión',
      vehicleId: 'Matrícula',
      vin: 'Bastidor (vale con los últimos 8 dígitos)',
      customerData: 'Datos del cliente',
      giverData: 'Datos de la persona que entrega el vehículo',
      lessee: 'Arrendatario',
      cifnif: 'CIF/NIF',
      numContract: 'Contrato Arrendatario Num',
      driverData: 'Datos de la persona que recoge el vehículo',
      name: 'Nombre',
      nameComplete: 'Nombre y apellidos',
      lastname: 'Primer apellido',
      lastname2: 'Segundo apellido',
      dni: 'DNI',
      drivingLicenseDueDate: 'Fecha Exp. Permiso Conducir',
      carData: 'Datos del vehículo',
      brand: 'Marca',
      modelName: 'Modelo',
      currentKilometers: 'KM. Iniciales',
      colorName: 'Color',
      deliveryCity: 'Lugar de Entrega',
      documentationDeliveredData: 'Documentación Entregada',
      equipmentDeliveredData: 'Equipamiento Entregado',
      accessoriesData: 'Accesorios',
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      documentTypes: 'Tipo de documento',
      documentId: 'Número de documento (DNI, NIE)',
      businessName: 'Razón social',
      cif: 'CIF',
      companyData: 'Datos de la empresa',
      contactData: 'Datos de contacto',
      attorneyData: 'Datos apoderado',
      documentsData: 'Documentos',
      companyName: 'Nombre (Razón Social)',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      selectFile: 'Seleccione un fichero',
      providerComment: 'Comentarios en el acta',
      driverProviderComment: 'Comentarios en el acta - Concesión',
      driverDriverComment: 'Comentarios en el acta - Conductor',
      cancelModalTitle: 'Cancelar acta',
      loadingModalTitle: 'Procesando...',
      cancelModalText: '¿Está seguro que quiere cancelar el acta?',
      cancelModalInputLabel: 'Introduzca el motivo de la cancelación',
      documentInvalid: 'Documentos inválidos.',
      checksMessageModalTitle: 'Guardar',
      checksMessageModalText:
        'No ha marcado todos los check en alguna de las secciones de Documentación Entregada y Equipo Entregado, pero si desea seguir adelante pulse en el botón Aceptar. Además recuerde que nos puede dejar un comentario para que podamos comunicarnos con el conductor',
      dataSavedOk: 'Los datos se han guardado correctamente',
      errorValidationProcess: 'Error en el proceso de validación.',
      advice: '¡Aviso importante!',
      errorIdentityDefault:
        'Con los datos que nos has proporcionado no existe ningún conductor activo. Si lo deseas, entra en contacto con nosotros. Gracias.',
      actSigned: 'Acta firmada',
      signLoadingText:
        'Su firma está siendo procesada. Por favor, no cierre el navegador, podría tardar varios segundos.',
      showFilesModal: {
        title: 'Documentos subidos',
        error: 'Error al cargar los documentos'
      },
      showFiles: 'Ver documentos'
    }
  }
};
